import React from "react"
import ReactTooltip from 'react-tooltip'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import {colors} from "../../utils/styles"
import {getGlobalStore} from "../../state/globalStore"
import {merge} from "../../utils/util"
import {logout} from "../../state/app/actions"
import {dragElement} from "../../utils/dragable"
import ClickableIcon from "./ClickableIcon"

const titleBarStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  height: 78,
  minHeight: 78,
  background: 'linear-gradient(to right, #0069a6 50%, #C7DEEB)',
  color: colors.white,
  paddingLeft: 20
}

const flexSpaceBetween = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 20,
  width: '100%'
}

const buttonStyle = {
  height: 20,
  cursor: 'pointer',
  marginRight: 25
}

const headerLeft = {
  alignItems: 'center',
  marginTop: -2
}

const headerSubtitle = {
  paddingLeft: 7,
  marginTop: 3,
  fontSize: '20px',
  fontWeight: 600
}

const finePrint = {
  marginTop: 1,
  color: colors.white
}

export class TitleBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleNewTab(history, location, url) {
    if (url) {
      window.open('#' + url, '_blank')
    } else {
      window.open('#' + location.pathname, '_blank')
    }
  }

  handleClose() {
    if (this.props.closeAction) {
      getGlobalStore().dispatch({type: this.props.closeAction})
    }
    if (this.props.closeFn) {
      this.props.closeFn()
    }
  }

  getCloseButton() {
    return (
        <div style={{marginRight: 20}}>
          <ClickableIcon imgId="close"
                         iconPath="images/chat-close-white.svg"
                         buttonClassName="close"
                         toolTipText="Close"
                         hoverIconPath="images/chat-close-hover.svg"
                         activeIconPath="images/chat-close-active.svg"
                         actionFunction={this.handleClose.bind(this)}
                         iconSize={15}/>
        </div>)
  }

  componentDidMount() {
    if (this.props.drag) {
      let anchor = document.getElementsByClassName("titleBar")
      if (anchor.length > 0) {
        // draggable titlebar is always on top, will get first as anchor
        anchor = (this.props.drag === 'chat-modal') ?
            document.getElementsByClassName("chat-modal")[0].firstChild : anchor[anchor.length - 1]
      }
      const container = document.getElementsByClassName(this.props.drag)[0]
      if (!container) {
        return
      }
      if (container.style.marginLeft.substr(0, 1) === "-") {
        console.error("cannot use drag with negative margin")
        return
      }
      dragElement(container, anchor)
    }
  }

  componentWillUnmount() {
    ReactTooltip.hide()
  }

  render() {
    const {
      title, subtitles, fineprint, rightDetails, titleStyle, delimiter,
      showCloseButton, showLogout, url, fineprintStyle
    } = this.props

    const delimiterToUse = delimiter ? delimiter : '|'
    const getSubtitles = subtitles && subtitles.map((s, i) => (
        <span key={i} style={headerSubtitle} className="h2">| {s}</span>))
    const cc = '%%%%'
    const finePrintList = fineprint && fineprint.filter(e => e != null).join(
        cc + ' ' + delimiterToUse + ' ' + cc).split(cc)
    .map((s, i) => (<span key={i}>{s}</span>))

    const rightDetailsList = rightDetails && rightDetails.map((s, i) => (
        <span key={i} style={{paddingRight: 10}}>{s}</span>)) || []

    if (url) {
      rightDetailsList.push(
          <span key="new-tab" id="new-tab" style={buttonStyle}
                onClick={this.handleNewTab.bind(this, history, location, url)}
                data-tip={"Open As New Tab"}>
            <img alt="new tab" src="images/open-new-tab.svg" style={{height: 26, width: 26}}/>
          </span>
      )
    }

    if (this.props.userProfile) {
      rightDetailsList.push(
          <img key="logo" alt="logo"
               src={this.props.userProfile.forCosco ? 'images/cosco/logo.png' : 'images/oocl/logo.svg'}
               style={{height: 54, marginRight: 20}}/>)
    }

    if (showLogout) {
      rightDetailsList.push(
          <div key="logout" id="logout" style={buttonStyle}
               onClick={this.props.actions.logout}
               data-tip={"Logout"}>
            <img alt="logout" src="images/logout-blue.svg" style={{height: 20}}/>
          </div>)
    }

    if (showCloseButton) {
      rightDetailsList.push(<span key="close-key">{this.getCloseButton()}</span>)
    }

    return (
        <div className="titleBar" style={merge(titleBarStyle, titleStyle)}>
          <span style={flexSpaceBetween}>
            <div style={headerLeft}>
              <div>
                <span className="h1">{title}</span>
                {getSubtitles}
              </div>
              {fineprint &&
                  <div style={merge(finePrint, fineprintStyle)} className="h4">
                    {finePrintList}
                  </div>}
            </div>
            <div className="h2" style={{display: 'flex', alignItems: 'center'}}>
              {rightDetailsList}
            </div>
          </span>
          <ReactTooltip class="icon-tooltip" place="left" effect="solid"/>
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAppInitialized: state.app.isAppInitialized,
    userProfile: state.userProfile,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({logout}, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleBar)
